import React, { useContext } from "react";
import Button from "@mui/material/Button";
import makeStyles from '@mui/styles/makeStyles';
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import config from "../config";
import messages from "../services/messages";

import LanguageContext from "../LanguageContext";

import UserService from "../services/UserService";
import firebase from "../firebase";
import moment from "moment";
import CardMedia from "@mui/material/CardMedia";

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: "8px",
  },
  contentContainer: {},
  headerContainer: {
    // cursor: "pointer",
  },
  media: {
    height: theme.spacing(20),
  },
  topic: {
    fontWeight: "700",
  },
}));

export default function LiveHelpCard(props) {
  const classes = useStyles();
  let { mobile } = UserService.getUserInfo();
  const language = useContext(LanguageContext);
  let meeting = props.meeting;

  return <>
    <Card className={classes.root} variant={"outlined"}>
      <CardMedia
        className={classes.media}
        image="/icons/live-help-cover.jpg"
        title="Live Help"
      />
      <CardContent className={classes.headerContainer}>
        <Grid
          container
          direction="row"
          justifyContent={"flex-start"}
          alignItems={"center"}
        >
          <Grid item xs={8}>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid item>
                <Typography variant={"body2"} className={classes.topic}>
                  {/* {messages["dashboard.liveHelp.cardTitle"][language]} */}
                  {meeting.sessionTopic}
                </Typography>
              </Grid>
            </Grid>

            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
            >
              {meeting.type === "upcoming" ? (
                <>
                  <Grid item>
                    <Typography variant={"body2"}>
                      {meeting.start_time.format("DD-MM-YYYY")}
                    </Typography>
                  </Grid>
                  &nbsp;&nbsp;
                  <Grid item>
                    <Typography variant={"body2"}>
                      {moment(meeting.start_time).format("hA")}
                      &nbsp;-&nbsp;
                      {moment(meeting.end_time).format("hA")}
                    </Typography>
                  </Grid>
                </>
              ) : (
                <>
                  <Grid item>
                    <Typography
                      variant={"body2"}
                      style={{ color: "#9D2123" }}
                    >
                      {messages["dashboard.liveHelp.ongoing"][language]}{" "}
                    </Typography>
                  </Grid>
                  &nbsp;&nbsp;
                  <Grid item>
                    <Typography variant={"body2"}>
                      {moment(meeting.end_time).format("h A")}{" "}
                      {messages["dashboard.liveHelp.till"][language]}
                    </Typography>
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>
          <Grid item xs={1}></Grid>
          {!meeting.unifyd ? (
            <Grid item xs={3} className={classes.cropImageContainer}>
              <>
                <Button
                  variant={"contained"}
                  aria-label="call"
                  color={"primary"}
                  size="medium"
                  onClick={() => {
                    firebase.analytics().logEvent("live_help_joined", {
                      mobile,
                      user_type: props.userType,
                      state: props.userState
                        ? props.userState.name_en
                        : "maharashtra",
                      join_type: "zoom",
                      user_source: props.userSource,
                    });
                  }}
                  href={meeting.join_url}
                  target={`_blank`}
                  disabled={meeting.type === "upcoming"}
                >
                  {meeting.type === "upcoming"
                    ? messages["dashboard.liveHelp.upcoming"][language]
                    : messages["dashboard.liveHelp.join"][language]}
                </Button>
              </>
            </Grid>
          ) : (
            <Grid item xs={3} className={classes.cropImageContainer}>
              <>
                <Button
                  variant={"contained"}
                  aria-label="call"
                  color={"primary"}
                  size="medium"
                  onClick={() => {
                    firebase.analytics().logEvent("live_help_joined", {
                      mobile,
                      user_type: props.userType,
                      state: props.userState
                        ? props.userState.name_en
                        : "maharashtra",
                      join_type: "unifyd",
                      user_source: props.userSource,
                    });
                  }}
                  href={`${
                    config.unifydBaseUrl
                  }index.html?mobile=${mobile}&state=${
                    props.userState ? props.userState.code : "MH"
                  }`}
                  disabled={meeting.type === "upcoming"}
                >
                  {meeting.type === "upcoming"
                    ? messages["dashboard.liveHelp.upcoming"][language]
                    : messages["dashboard.liveHelp.join"][language]}
                </Button>
              </>
            </Grid>
          )}

          <Grid item xs={1}></Grid>
        </Grid>
      </CardContent>
    </Card>
  </>;
}
